module.exports = __webpack_public_path__ + "media/images/nonbiri@2x-2b8b0863be98c2eccdf43bec06d654ab.jpg";